export default "__VITE_ASSET__BEs_cK85__"